import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "list-form__controls" }

import { onBeforeUnmount, ref } from 'vue'

import { CustomListForm } from '@/models/custom.lists'
import { PublicInterface } from '@/models/interfaces'

import BasePopup from '@/components/ui/BasePopup.vue'
import InputWithContextMenu from '@/app/components/InputWithContextMenu.vue'
import AppButton from '@/app/components/button/AppButton.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'CustomListForm',
  props: {
    view: {}
  },
  setup(__props: any, { expose: __expose }) {

const props = __props

const basePopup = ref<InstanceType<typeof BasePopup> | null>(null)

async function submitForm(): Promise<void> {
  const success = await props.view.submitForm()

  // Only close the popup if the form was submitted
  // without errors.
  if (success) {
    basePopup.value?.hide()
  }
}

function show(): void {
  basePopup.value?.show()
}

onBeforeUnmount(() => {
  props.view.clearState()
})

__expose({ show })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BasePopup, {
    ref_key: "basePopup",
    ref: basePopup,
    title: __props.view.formTitle,
    class: "list-form",
    compact: true,
    onHide: _cache[1] || (_cache[1] = ($event: any) => (__props.view.clearState()))
  }, {
    default: _withCtx(() => [
      _createElementVNode("form", {
        class: "list-form__form",
        onSubmit: _withModifiers(submitForm, ["prevent"])
      }, [
        _cache[3] || (_cache[3] = _createElementVNode("label", {
          class: "list-form__label",
          for: "list-title"
        }, "List title", -1)),
        _createVNode(InputWithContextMenu, {
          id: "list-title",
          modelValue: __props.view.title,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((__props.view.title) = $event)),
          class: "list-form__input",
          type: "text",
          placeholder: "Choose a title"
        }, null, 8, ["modelValue"]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.view.errors, (error, i) => {
          return (_openBlock(), _createElementBlock("p", {
            key: i,
            class: "list-form__error"
          }, _toDisplayString(error), 1))
        }), 128)),
        _createElementVNode("div", _hoisted_1, [
          _createVNode(AppButton, {
            class: "list-form__btn list-form__btn--cancel",
            outlined: true,
            type: "button",
            onClick: basePopup.value?.hide
          }, {
            default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
              _createTextVNode("Cancel", -1)
            ]))]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(AppButton, {
            class: "list-form__btn list-form__btn--submit",
            type: "submit",
            loading: __props.view.isLoading,
            disabled: __props.view.isConfirmBtnDisabled
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(__props.view.confirmButtonLabel), 1)
            ]),
            _: 1
          }, 8, ["loading", "disabled"])
        ])
      ], 32)
    ]),
    _: 1
  }, 8, ["title"]))
}
}

})